module.exports = __webpack_public_path__ + "img/Mountain.6876a649.png";